import ngCache from 'angular-cache';
import { CacheProvider } from './cache.provider';
import { CacheFactoryWrapper } from './cache.factory';

export default angular
  .module('ng1-cache', [ngCache])
  .provider('cache', CacheProvider)
  .factory('cacheFactory', CacheFactoryWrapper)
  .name;
